<template>
  <v-card>
    <div v-if="loading" class="w-100 flex-div justify-center">
      <v-progress-circular
      class="my-4"
      width="2"
      indeterminate
      color="primary"
      ></v-progress-circular>
    </div>
    <div v-else-if="$isEmpty(geoLocation.coords)" class="w-100 pointer" @click="$emit('click')" >
      <div class="flex-div align-center py-2 px-2">
        <div class="flex-div flex-column align-start grow pl-2 ">
          <span class="font-weight-bold text-uppercase">Me géolocaliser</span>
          <span class="caption text-none">Trouver le point de vente le plus proche</span>
        </div>
        <div><v-icon small class="mx-2">my_location</v-icon></div>
      </div>
    </div>
    <template v-else>
      <div v-if="!nearestPos">
        <div class="flex-div align-center py-2 px-2">
          <div><v-icon small class="mx-2">error</v-icon></div>
          <span class="caption text-none align-center">Aucun point de ventes dans les alentours</span>
        </div>
      </div>
      <pos-card v-else :pos="nearestPos" :origin="geoLocation.coords" />
    </template>
  </v-card>
</template>

<script>
import PosCard from '@/components/PosCard.vue'

export default {
  components: {
    PosCard
  },
  props: {
    nearestPos: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      required: true
    },
    geoLocation: {
      require: true
    }
  }
}
</script>
